'use client';
import { createStyles, rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const HANDLE_SIZE = 20;
var useStyles = createStyles((theme, { radius })=>{
    return {
        root: {},
        backdrop: {},
        body: {
            height: 'min-content'
        },
        header: {},
        title: _extends({
            userSelect: 'none',
            padding: theme.fn.space('2s 4s 3s')
        }, theme.fn.typography({
            variant: 'heading',
            size: 'sm1',
            color: 'text.medium'
        })),
        content: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            maxHeight: 'calc(100vh - env(safe-area-inset-bottom))',
            borderRadius: theme.fn.borderRadius(`${radius} ${radius} 0 0`),
            overflow: 'hidden',
            display: 'flex',
            flex: '0 0 100%',
            flexDirection: 'column',
            background: theme.palette.modal.background,
            // For bottom-positioned drawer
            paddingTop: rem(HANDLE_SIZE)
        },
        inner: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'flex-end'
        },
        draggable: {
            touchAction: 'none'
        },
        dragHandleBar: {
            position: 'absolute',
            display: 'flex',
            alignSelf: 'stretch',
            alignItems: 'center',
            justifyContent: 'center',
            userSelect: 'none',
            // For bottom-positioned drawer
            height: rem(HANDLE_SIZE),
            width: '100%',
            top: 0,
            left: 0,
            right: 0
        },
        dragHandle: {
            background: theme.palette.text.quaternary,
            borderRadius: theme.fn.borderRadius('round'),
            pointerEvents: 'none',
            // For bottom-positioned drawer
            height: theme.fn.space('1s'),
            width: 32,
            transition: 'width 100ms ease-out',
            '&[data-active=true]': {
                width: 48
            }
        }
    };
});

export { HANDLE_SIZE, useStyles as default };
//# sourceMappingURL=SwipeableDrawer.styles.js.map
